/* Nuzzo — minimal progressive-enhancement JS.
   1) Reveal-on-scroll: adds `is-visible` to `.reveal` elements. Content is fully
      visible without JS and when reduced motion is preferred.
   2) Header scroll state: toggles `is-scrolled` for the sticky header shadow.
   No dependencies; safe to defer. Interactive components (mobile drawer, sliders,
   product forms) ship their own scoped scripts via {% javascript %}. */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initReveals() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;

    if (prefersReduced || !("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.1 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initHeaderScroll() {
    var header = document.querySelector("[data-sticky-header]");
    if (!header) return;

    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function init() {
    initReveals();
    initHeaderScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
